import React from "react";
import { useLocation } from "react-router-dom";
import ProfileImagePreview from "../../../componenets/FormikReusable/ProfileImagePreview";

const VoterFormDataDisplay = () => {
  const location = useLocation();
  const data = location.state;
  console.log("VoterFormData", data);

  return (
    <>
      <div
        className="container shadow-lg "
        style={{ width: "fit-content", textAlign: "center", marginTop: "25px" }}
      >
        <ul class="list-group">
          <li class="list-group-item active">
            {" "}
            <ProfileImagePreview file={data.file} />{" "}
          </li>
          <li class="list-group-item"> Full Name: {data.fullname} </li>
          <li class="list-group-item"> Email: {data.email} </li>
          <li class="list-group-item"> ContactNumber: {data.contactnumber} </li>
          <li class="list-group-item"> Age: {data.age} </li>
          <li class="list-group-item">
            {" "}
            IdentityCard Number: {data.identityId}{" "}
          </li>
          <li class="list-group-item"> VoterCard Number: {data.voterId} </li>
          <li class="list-group-item"> PanCard Number: {data.panId} </li>
          <li class="list-group-item">
            {" "}
            Address
            <ul class="list-group">
              {data.address.map((curr, index) => {
                return (
                  <>
                    <li class="list-group-item" key={index}>
                      {" "}
                      Address- {index + 1} :- {curr.street} , {curr.city},{" "}
                      {curr.zipcode} ,{curr.state}{" "}
                    </li>
                  </>
                );
              })}
            </ul>
          </li>
        </ul>
      </div>
    </>
  );
};

export default VoterFormDataDisplay;
